export interface GetProjectLotsResponse {
  count: number;
  capacities: {
    lotMax: number,
    lotMin: number,
    lotType: {
      lotTypeCode: string,
    }[],
  };
}
